






















































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { InoutCase, InoutCasesQuery, Query } from "@/models/CaseModel";
import { UserModule } from "@/store/modules/User";
import SystemModel from "@/models/SystemModel";
import trackEvent from "@/plugins/track-event";
import DebtCollection from "@/components/icons/debt-collection.vue";
import Service from "@/components/icons/service.vue";

@Component({ components: { DebtCollection, Service } })
export default class RegisteredCasesOverview extends Vue {
    isLoadingRegister = false;
    isLoadingRegistered = true;
    registeredCases: InoutCase[] = [];
    registeredCasesTotal = 0;
    userModule = UserModule;
    systemModel = SystemModel;
    editMode = false;

    get isLoadingSystems() {
        return this.userModule.systems.length === 0;
    }

    @Prop(Object)
    query!: Query;

    @Prop()
    updateRegisteredCases!: boolean;

    async created(): Promise<void> {
        if (this.query) {
            trackEvent("pageView", this.$route.name as string);
            this.isLoadingRegister = true;

            await this.fetchRegisteredCases();
            this.isLoadingRegister = false;

            if (this.query.caseId) {
                const editCase = this.registeredCases.find(item => item.caseId === this.query.caseId);
                if (editCase) {
                    this.mapToWeb(editCase);
                }
            }
        }
    }

    async fetchRegisteredCases() {
        // TO DO: fetch only service cases?
        this.isLoadingRegistered = true;
        try {
            const { data } = await this.$api.graphql(
                InoutCasesQuery(this.query, [{ path: "isDeleted", value: "0" }], [{ path: "rowId", descending: true }])
            );
            this.registeredCases = data.inoutCases.items;
            this.registeredCasesTotal = data.inoutCases.totalCount;
        } catch (error) {
            this.$notifications.error({ message: this.$t("registerCases.fetchRegCasesFail") as string });
            this.$apm.captureError(error as any);
        }

        this.isLoadingRegistered = false;
    }

    getSystem(systemName: string) {
        return this.userModule.systems.filter(s => s.systemName === systemName)[0];
    }

    onPageChangeActive(page: number) {
        this.query.currentPage = page;
    }

    editCase(index: number) {
        this.mapToWeb(this.registeredCases[index]);
    }

    async mapToWeb(caseData: InoutCase): Promise<void> {
        this.editMode = true;
        this.$emit("editServiceCase", caseData);
    }

    confirmDeleteCase(caseId: string) {
        this.$buefy.dialog.confirm({
            title: this.$t("registerCases.deleteCaseTitle") as string,
            message: this.$t("registerCases.deleteCaseMessage") as string,
            cancelText: this.$t("registerCases.cancel") as string,
            confirmText: "Ok",
            type: "is-success",
            onConfirm: () => {
                this.deleteCase(caseId);
            },
        });
    }

    async deleteCase(caseId: string) {
        try {
            await this.$api.graphql({
                query: `mutation($caseId: String!) {
                                deleteInoutCase(caseId: $caseId) {
                                    caseId
                                }
                            }`,
                variables: { caseId },
            });

            this.$notifications.success({
                message: this.$t("registerCases.deleteCaseSuccess", { caseId }) as string,
            });

            this.fetchRegisteredCases();
            this.$emit("deletedRegisteredCase");
        } catch (error) {
            this.$notifications.error({ message: this.$t("registerCases.deleteCaseFail") as string });
            this.$apm.captureError(error as any);
        }
    }

    @Watch("query.perPage")
    @Watch("query.currentPage")
    queryUpdatedActive(): void {
        this.fetchRegisteredCases();
    }

    @Watch("updateRegisteredCases")
    updateCases() {
        this.fetchRegisteredCases();
    }
}
